import { Checkbox, Grid } from '@mui/material';
import React, { useState } from 'react'
import IconsColor from '../../utility/iconsColor';
import GlobalButton from '../../utility/globalButton/button';
import globalStyles from '../../../assets/styles/global.module.scss';
import styles from "../../../assets/styles/componentStyles/chatbot.module.scss";
import { primaryColor } from '../../../utils/colors';

interface ResetChatConfirmationPopupProps {
    publishChatbot: (flagReset: boolean) => Promise<void>,
} 

const ResetChatConfirmationPopup: React.FC<ResetChatConfirmationPopupProps> = (props) => {
    
    const { publishChatbot } = props;

    const [flagReset, setFlagReset] = useState<boolean>(true);

    return (
        <>
            <Grid container className={globalStyles.flexColumn}  >
                <Grid item className={globalStyles.deleteConfirmHeaderPopup}>
                    <Grid container >
                        <Grid item className={globalStyles.deleteConfirmPopupStyle}>
                            <IconsColor iconName="reset" width="21px" height="21px" fillColor={primaryColor} />
                        </Grid>
                        <Grid item >
                            <Grid container className={globalStyles.flexColumn}>
                                <Grid item className={globalStyles.deleteConfirmPopupTextStyle}>
                                    Reset Confirmation
                                </Grid>
                                <Grid item className={globalStyles.deleteConfirmPopupSubTextStyle}>
                                    <Grid container className={globalStyles.contentCenter} >
                                        <Grid item>
                                            <Checkbox 
                                                className={styles.checkedIcon} 
                                                disableRipple 
                                                checked={flagReset}
                                                onChange={(event) => { setFlagReset(event.target.checked) }} 
                                            />
                                        </Grid>
                                        <Grid item className={styles.checkboxStyle}>Reset all chatbot conversations</Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item className={globalStyles.deleteConfirmButtonsPopup}>
                    <Grid container className={globalStyles.contentEnd} >
                        <Grid item className={globalStyles.savebuttonStyle} >
                            <GlobalButton 
                                buttonText='Go Live' 
                                flagFullWidth 
                                className='primaryButtonStyle'
                                onClick={() => publishChatbot(flagReset)} 
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default ResetChatConfirmationPopup
